import React from "react";
import { ScaleQuestion } from "@/components/ScaleQuestion";
import { NEED_IMAGES } from "@/data/needs";

const ProgressBar = ({ current, total, t }) => {
  const pct = Math.round((current / total) * 100);
  return (
    <div className="mb-8" data-testid="passation-progress">
      <div className="flex items-baseline justify-between mb-2">
        <span className="text-sm uppercase tracking-[0.18em] text-[var(--ink-soft)]">
          {t.needLabel} {current} {t.needOf} {total}
        </span>
        <span className="font-serif-title text-2xl text-[var(--gold)]" data-testid="progress-pct">
          {pct} %
        </span>
      </div>
      <div className="h-3 w-full rounded-full bg-[var(--beige)] overflow-hidden">
        <div className="h-full rounded-full bg-[var(--gold)] transition-all duration-500 ease-out" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export const NeedStep = ({ need, indexNumber, total, values, onChange, onPrev, onNext, lang, t, scale }) => {
  const answered = (values || []).filter((v) => Number.isFinite(v)).length;
  const items = need.items[lang];
  const complete = answered === items.length;

  return (
    <div className="animate-fade-up" key={need.key}>
      <ProgressBar current={indexNumber} total={total} t={t} />

      <div className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] overflow-hidden mb-6 grid grid-cols-1 md:grid-cols-5">
        <div className="p-6 sm:p-8 md:col-span-3 order-2 md:order-1 flex items-center">
          <h2 className="font-serif-title text-3xl sm:text-4xl text-[var(--gold)]">{need.name[lang]}</h2>
        </div>
        <div
          className="md:col-span-2 order-1 md:order-2 min-h-[180px] md:min-h-full bg-center bg-cover"
          style={{ backgroundImage: `url('${NEED_IMAGES[need.key]}')` }}
          role="img"
          aria-label={need.short[lang]}
          data-testid={`need-image-${need.key}`}
        />
      </div>

      <div className="space-y-3">
        {items.map((statement, i) => (
          <ScaleQuestion
            key={`${need.key}-${i}`}
            id={`${need.key}-${i}`}
            statement={statement}
            index={i + 1}
            labels={scale}
            value={values?.[i]}
            onChange={(v) => onChange(i, v)}
          />
        ))}
      </div>

      <div className="flex items-center justify-between mt-8 no-print">
        <button onClick={onPrev} data-testid="btn-prev" className="px-6 py-3 rounded-full border border-[var(--gold)] text-[var(--gold)] font-medium hover:bg-[var(--gold)] hover:text-white transition-colors">
          {t.prev}
        </button>
        <button
          onClick={onNext}
          disabled={!complete}
          data-testid="btn-next"
          className={`px-8 py-3 rounded-full font-medium transition-all ${complete ? "bg-[var(--gold)] text-white hover:brightness-105 shadow-sm" : "bg-[var(--beige)] text-[var(--ink-soft)] cursor-not-allowed"}`}
        >
          {t.next}
        </button>
      </div>
      {!complete && <p className="text-center text-xs text-[var(--ink-soft)] mt-3 no-print">{t.completeItems}</p>}
    </div>
  );
};
